var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterLine = function SvgFilterLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.667V4h-.667L10 9v5.667H6V9L2.667 4H2V2.667h12ZM4.27 4l3.063 4.596v4.738h1.334V8.596L11.73 4H4.269Z",
    fill: "#2F3137"
  })));
};
export default SvgFilterLine;